import React from 'react';
import { UncontrolledDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NotificationOptions from './NotificationOptions';
import { useInterval, useUnifiedFetch, useUnifiedMutate } from '../../hooks';

const styles = {
  unreadNotificationsCount: {
    position: 'absolute',
    zIndex: 2,
    top: '10px',
    left: '17px',
    fontSize: '12px',
    fontWeight: '700',
    color: '#fe9016',
  },
};

function NotificationsBell() {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [unreadNotifications, setUnreadNotifications] = React.useState([]);

  const { data: notifications, fetchData: fetchNotifications } = useUnifiedFetch(
    'users/notifications',
    undefined,
    true,
  );
  const {
    mutate: callNotificationReadApi,
    isLoading: isUpdatingNotificationsReadStatus,
  } = useUnifiedMutate(true);

  const unreadNotificationsCount = unreadNotifications?.length;

  const updateNotificationReadStatus = React.useCallback(async () => {
    if (!unreadNotifications?.length || isUpdatingNotificationsReadStatus) {
      return;
    }

    const endpoint = 'users/notification/read';
    const method = 'POST';

    await callNotificationReadApi(endpoint, method, { notifications: unreadNotifications });
    setUnreadNotifications([]);
  }, [unreadNotifications, isUpdatingNotificationsReadStatus, callNotificationReadApi]);

  const handleToggle = () => {
    setIsDropdownOpen(preValue => !preValue);
  };

  useInterval(() => {
    fetchNotifications();
  }, 30000);

  React.useEffect(() => {
    setUnreadNotifications(notifications);
  }, [notifications]);

  React.useEffect(() => {
    if (isDropdownOpen) {
      updateNotificationReadStatus();
    }
  }, [isDropdownOpen, updateNotificationReadStatus]);

  return (
    <UncontrolledDropdown nav inNavbar isOpen={isDropdownOpen} toggle={handleToggle}>
      <DropdownToggle nav className="nav-link text-left">
        {unreadNotificationsCount > 0 && (
          <span style={styles.unreadNotificationsCount}>{unreadNotificationsCount}</span>
        )}
        <FontAwesomeIcon icon="bell" size="2x" />
      </DropdownToggle>
      <DropdownMenu right className="mb-2">
        <NotificationOptions data={notifications} />
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

export default NotificationsBell;
